//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PID.js";
import "../no/Builder.js";
import "../Diagramming/Diagramming.TextStyleBuilder.js";
import "../no/Diagramming.js";
import "../no/ugmath.js";
import "../no/PDM.js";
let d=[[[0,"ControlLoopName",1,0],[0,"FunctionId",1,0],[0,"InstrumentationType",1,0],[0,"LeaderArrowhead",1,0],[0,"LeaderStubLength",1,0],[0,"LeaderStubSide",1,0],[0,"LeaderUsed",1,0],[0,"MeasurementVariable",1,0],[0,"OwningControlLoop",1,"PLAS.Run",0],[0,"OwningControlLoopType",1,0],[0,"SymbolSize",1,0],[0,"SymbolType",1,0],[1,"TextStyle",0,"Diagramming.TextStyleBuilder",0]],[[[],"GetLocation",{R_:{location:''}},0,0],[["location"],"SetLocation",{},1,0],[["pipe","connectionId","segementId","percent"],"SetInlineSymbolLocation",{},4,0],[["pipe","connectionId","segementId","percent"],"GetInlineSymbolLocation",{},0,0],[["pipe","connectionId"],"GetNewInlineConnection",{},0,0],[["fromPortId","toInstrumentSymbol","toPortId"],"SetAttachedInstrumentSymbol",{},3,0],[[],"Detach",{},0,0],[[],"GetNode",{R_:{node:"Diagramming.Node"}},0,0],[["reference","point","connectionSegementId"],"GetLeaderTerminator",{},0,0],[["reference","point","connectionSegementId"],"SetLeaderTerminator",{},3,0]],[]];
SPLM.PID.InstrumentationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PID.InstrumentationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;